import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import Constants from "../common/Constants";
import { IIndexTypeCategory } from "../model/IndexTypeCategory";
import IndexTypeCategoryMapper from "../service/IndexTypeCategoryMapper";
import IndexTypeCategoryParamMapper from "../service/IndexTypeCategoryParamMapper";

export default class UpdateIndexTypeCategoryInteractor {
  private updateResource: UpdateResourceInteractor<IIndexTypeCategory>;

  constructor({ updateResource }: any) {
    this.updateResource = updateResource;
  }

  async execute(model: IIndexTypeCategory) {
    return this.updateResource.execute(
      Constants.indexCategoryBasePath,
      IndexTypeCategoryMapper,
      IndexTypeCategoryParamMapper,
      model,
      model.id
    );
  }
}
